import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import "../staff/staff.css";
import "./internal.css";

export const VOID_REASONS = [
  ["wrong_patient", "Wrong patient"],
  ["duplicate", "Duplicate"],
  ["entered_in_error", "Entered in error"],
];

/*
 * Void a saved staff form that is not in the EMR yet (its author or an
 * admin): the answers and its PDF are removed. A fixed reason, no free text.
 *   open, busy, error, onClose(), onSubmit(reason)
 */
export default function VoidDialog({ open, busy, error, onClose, onSubmit, title }) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason("");
  }, [open]);
  return (
    <Dialog open={!!open} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs" aria-labelledby="fwi-void-title">
      <div className="fws fwi-dlg" data-testid="void-dialog">
        <h2 id="fwi-void-title" className="fws-section-title">Void {title || "this form"}?</h2>
        <p className="fws-help">Its answers and PDF are removed. This can't be undone.</p>
        <div className="fws-radios" role="radiogroup" aria-label="Reason">
          {VOID_REASONS.map(([v, l]) => (
            <label key={v} className={`fws-radio${reason === v ? " is-on" : ""}`}>
              <input type="radio" name="fwi-void-reason" value={v} checked={reason === v} onChange={() => setReason(v)} />
              <span className="fws-radio-title">{l}</span>
            </label>
          ))}
        </div>
        {error && <div className="fws-alert fws-alert-error" role="alert">{error}</div>}
        <div className="fws-row" style={{ justifyContent: "flex-end" }}>
          <button type="button" className="fws-btn fws-btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="button" className="fws-btn fws-btn-danger" disabled={!reason || busy} onClick={() => onSubmit(reason)}>
            {busy ? "Voiding…" : "Void form"}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
